import { last, min, max, inRange, round } from 'lodash-es';

export const makeNumbersRange = (data, size = 4) => {
  const allNumberValues = data.flat().reduce((result, item) => {
    const numberValue = parseFloat(item);
    return Number.isNaN(numberValue) ? result : result.concat(numberValue);
  }, []);

  const minNumberValue = min(allNumberValues);
  const maxNumberValue = max(allNumberValues);
  const stepSize = round((maxNumberValue - minNumberValue) / (size - 1), 2);

  const rangeWithoutMax = Array(size - 1)
    .fill(0)
    .map((_, i) => minNumberValue + i * stepSize);
  return [...rangeWithoutMax, maxNumberValue];
};

export const makeRangeMatcher = (numbersRange) => {
  const doubleTailRange = [...numbersRange, last(numbersRange)];

  return doubleTailRange.map((number, index, array) => {
    if (index === 0) return (value) => value < number;
    if (index === array.length - 1) return (value) => value >= number;
    return (value) => inRange(value, array[index - 1], number);
  });
};
